import * as React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Spinner } from "components/common";
import { useFetchDataAdapter } from "components/lookup-tables/hooks/useLookupTablesAPI";
import AdapterShow from "./adapter-show";
function AdapterView() {
  const { t } = useTranslation("lookup_tables");
  const { adapterIdOrName } = useParams();
  const { dataAdapter, loadingDataAdapter } = useFetchDataAdapter(adapterIdOrName);
  if (loadingDataAdapter) return /* @__PURE__ */ React.createElement(Spinner, { text: t("adapter_view.loading") });
  return /* @__PURE__ */ React.createElement(AdapterShow, { dataAdapter });
}
export default AdapterView;
